import { render, staticRenderFns } from "./PhoneLoginButton.vue?vue&type=template&id=6c80ca32&"
import script from "./PhoneLoginButton.vue?vue&type=script&lang=js&"
export * from "./PhoneLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLoginButton.vue?vue&type=style&index=0&id=6c80ca32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports